<template>
  <div id="contenedor-listado-minuta-asuntos">
    <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn
        @click="mostrarAgregarAsuntos = true"
        color="primary"
        rounded>
        <v-icon left>
          mdi-plus
        </v-icon>
        Agregar asuntos
      </v-btn>
    </v-toolbar>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Clave</th>
            <th width="50%">Asunto</th>
            <th>Responsables</th>
            <th width="9%">Estatus</th>
            <th width="20%">Acciones requeridas</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="tema in getAsuntosAgrupados">
            <template>
              <tr :key="tema.id" class="font-weight-black grey lighten-4">
                <td>{{ tema.clave }}</td>
                <td colspan="4">{{ tema.descripcion }}</td>
              </tr>
            </template>

            <template
              v-for="subtema in tema.subtemas">
              <template>
                <tr :key="subtema.id" class="font-weight-medium grey lighten-5">
                  <td></td>
                  <td colspan="4">
                    <div class="ml-1">
                      {{ subtema.descripcion }}
                    </div>
                  </td>
                </tr>
              </template>

              <template
                v-for="asunto in subtema.asuntos">
                <template>
                  <tr :key="asunto.id">
                    <td>
                    </td>
                    <td>
                      <div class="d-flex align-center ml-3">
                        <div>
                          {{ asunto.numero }}.-
                        {{ asunto.descripcion }}
                        </div>
                        <div class="ml-2">
                          <v-chip small @click="generarAcuerdo(asunto)">
                            <v-icon left small>mdi-handshake</v-icon>
                            Generar Acuerdo
                          </v-chip>
                        </div>
                        <div class="ml-2">
                          <v-chip small color="error" @click="preRemoverAsuntoMinuta(asunto)">
                            <v-icon left small>mdi-close</v-icon>
                            Remover
                          </v-chip>
                        </div>
                      </div>
                    </td>
                    <td>{{ asunto.responsables }}</td>
                    <td>
                      <custom-text-field
                        v-model.number="asunto.porcentaje"
                        dense
                        hide-details
                        suffix="%"
                        :rules="avanceRules">
                      </custom-text-field>
                    </td>
                    <td>
                      <custom-text-area
                        v-model="asunto.accionesRequeridas"
                        rows="2"
                        class="py-1">
                      </custom-text-area>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog
      v-model="mostrarAgregarAsuntos"
      width="750"
      scrollable>
      <v-card>
        <v-card-title>
          Agregar asuntos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarAgregarAsuntos">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <AgregarAsuntos
            ref="agregarAsuntos"
            :id-contrato="idContrato"
            :id-minuta="idMinuta"
            v-on:asunto-agregado="actualizarListadoAsuntos">
          </AgregarAsuntos>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="mostrarPreRemoverAsunto"
      persistent
      width="450">
      <v-card>
        <v-card-title>
          Remover asunto
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          ¿Estás seguro de remover el asunto?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="mostrarPreRemoverAsunto = false"
            text>
            Cancelar
          </v-btn>
          <v-btn
            @click="removerAsuntoMinuta(esteAsunto)"
            color="success"
            outlined>
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarGenerarAcuerdo" persistent width="450">
      <NuevoAcuerdo :id-minuta="idMinuta" :asunto="esteAsunto"
      v-on:cerrar="cancelarGenerarAcuerdo" />
    </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CONTRATO_TEMAS from '@/graphql/querys/contratiastas/contratoTemas.gql';
import CONTRATO_MINUTA_ASUNTOS from '@/graphql/querys/administracion/minutas/contratoMinutaAsuntos.gql';
import REMOVER_CONTRATO_MINUTA_ASUNTO from '@/graphql/mutations/administracion/minutas/asuntos/removerContratoMinutaAsunto.gql';
import ACTUALIZAR_CONTRATO_MINUTA_ASUNTOS from '@/graphql/mutations/administracion/minutas/asuntos/actualizarMultipleContratoMinutaAsunto.gql';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomTextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import NuevoAcuerdo from '@/components/administracion/minutas/acuerdos/Nuevo.vue';
import AgregarAsuntos from '../asuntos/Agregar.vue';

export default {
  name: 'MinutasAsuntos',
  components: {
    CustomTextField,
    CustomTextArea,
    AgregarAsuntos,
    NuevoAcuerdo,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    idMinuta: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mostrarAgregarAsuntos: false,
      mostrarPreRemoverAsunto: false,
      mostrarGenerarAcuerdo: false,
      esteAsunto: null,
      avanceRules: [
        (v) => v >= 0 || 'El avance debe ser mayor o igual a 0',
        (v) => v <= 100 || 'El avance debe ser menor o igual a 100',
      ],
    };
  },
  apollo: {
    contratoTemas: {
      query: CONTRATO_TEMAS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoMinutaAsuntos: {
      query: CONTRATO_MINUTA_ASUNTOS,
      variables() {
        return {
          idMinuta: this.idMinuta,
        };
      },
    },
  },
  methods: {
    agruparPorTema(asuntos) {
      return asuntos.reduce((acumulador, item) => {
        const tema = item.asunto?.subTema?.tema;
        const subTema = item.asunto?.subTema;

        if (!tema || !subTema) return acumulador;

        const { id: temaId, clave, descripcion: temaDescripcion } = tema;
        const { id: subTemaId, descripcion: subTemaDescripcion } = subTema;

        // Buscar si el tema ya está en el acumulador
        let grupoTema = acumulador.find((grp) => grp.id === temaId);

        if (!grupoTema) {
          grupoTema = {
            id: temaId, clave, descripcion: temaDescripcion, subtemas: [],
          };
          acumulador.push(grupoTema);
        }

        // Buscar si el subtema ya está en el tema
        let grupoSubtema = grupoTema.subtemas.find((st) => st.id === subTemaId);

        if (!grupoSubtema) {
          grupoSubtema = { id: subTemaId, descripcion: subTemaDescripcion, asuntos: [] };
          grupoTema.subtemas.push(grupoSubtema);
        }

        // Ordenar los subtemas
        grupoTema.subtemas.sort((a, b) => this.ordenarPorValor(a.descripcion, b.descripcion));

        // Agregar el asunto al subtema correspondiente
        grupoSubtema.asuntos.push({
          id: item.id,
          idMinuta: item.idMinuta,
          idContratoAsunto: item.idContratoAsunto,
          numero: item.asunto.numero,
          descripcion: item.asunto.descripcion,
          responsables: item.asunto.responsables,
          porcentaje: item.porcentaje,
          accionesRequeridas: item.accionesRequeridas,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
        });

        grupoSubtema.asuntos.sort((a, b) => this.ordenarPorValor(a.numero, b.numero));

        return acumulador;
      }, []);
    },
    cerrarAgregarAsuntos() {
      this.mostrarAgregarAsuntos = false;
    },
    preRemoverAsuntoMinuta(asunto) {
      this.mostrarPreRemoverAsunto = true;
      this.esteAsunto = asunto;
    },
    async removerAsuntoMinuta(asunto) {
      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_MINUTA_ASUNTO,
        variables: {
          id: asunto.id,
        },
      });
      eventBus.$emit('acuerdos-vencidos-actualizar');
      this.actualizarListadoAsuntos();
      this.mostrarPreRemoverAsunto = false;
    },
    async actualizarListadoAsuntos() {
      await this.$apollo.queries.contratoMinutaAsuntos.refetch({
        idMinuta: this.idMinuta,
      });
    },
    extraerAsuntos(temas) {
      return temas.flatMap((tema) => tema.subtemas.flatMap((subtema) => subtema.asuntos));
    },
    async actualizarMinutaAsuntos() {
      const asuntos = this.extraerAsuntos(this.getAsuntosAgrupados)
        .map(({ id, porcentaje, accionesRequeridas }) => ({ id, porcentaje, accionesRequeridas }));

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CONTRATO_MINUTA_ASUNTOS,
        variables: {
          minutaAsuntos: asuntos,
        },
      }).then(() => {
        this.mixMensajeSuccess();
        eventBus.$emit('acuerdos-vencidos-actualizar');
        this.cerrarAgregarAsuntos();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
    },
    generarAcuerdo(asunto) {
      this.mostrarGenerarAcuerdo = true;
      this.esteAsunto = asunto;
    },
    cancelarGenerarAcuerdo() {
      this.mostrarGenerarAcuerdo = false;
      this.esteAsunto = null;
    },
    ordenarPorValor(a, b) {
      if (Number(a) && Number(b)) {
        return Number(a) - Number(b);
      }

      return a.localeCompare(b);
    },
  },
  computed: {
    getAsuntosAgrupados() {
      if (!this.contratoMinutaAsuntos) {
        return [];
      }

      return this.agruparPorTema(this.contratoMinutaAsuntos)
        .sort((a, b) => this.ordenarPorValor(a.clave, b.clave));
    },
  },
};
</script>

<style lang="scss">

</style>
